import { Injectable, effect, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UiPreferencesService {
  private readonly themeStorageKey = 'expert-dark-mode';

  readonly darkMode = signal(false);

  constructor() {
    const storedValue = this.readStoredTheme();
    if (storedValue !== null) {
      this.darkMode.set(storedValue);
    }

    // Global elements (e.g. the flatpickr calendar popup) render outside any
    // component's DOM subtree, so they need a document-level hook to theme.
    effect(() => {
      document.documentElement.classList.toggle('dark', this.darkMode());
    });
  }

  toggleDarkMode(): void {
    const nextValue = !this.darkMode();
    this.darkMode.set(nextValue);
    this.persistTheme(nextValue);
  }

  private readStoredTheme(): boolean | null {
    try {
      const value = localStorage.getItem(this.themeStorageKey);
      if (value === 'true') {
        return true;
      }

      if (value === 'false') {
        return false;
      }
    } catch {
      return null;
    }

    return null;
  }

  private persistTheme(value: boolean): void {
    try {
      localStorage.setItem(this.themeStorageKey, String(value));
    } catch {
      // Ignore storage access failures and keep the in-memory preference.
    }
  }
}
